exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-treeview-node:nth-child(odd){background:#f4f4f4}.v-treeview>.v-treeview-node--leaf{padding-left:0!important;margin-left:0!important}.v-treeview-node__children{background:#fff}", ""]);

// exports
